import { temAcesso } from '@/shared/auth/temAcesso'

const Entregas = () => import('./Entregas.vue')
const Entrega = () => import('./Entrega.vue')

export default {
    path: 'entregas',
    name: 'Gerentes_Entregas',
    component: Entregas,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-GER-ENTR-00')) {
            next()
        }
    },
    children: [
        {
            path: ':entregaId',
            name: 'Gerentes_Entregas_Detalhar',
            component: Entrega,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CRED-GER-ENTR-00')) {
                    next()
                }
            }
        }
    ]
}
